<ng-content></ng-content>
<atlas-top-bar-items
  [dropdownItems]="dropdownItems()"
  [hideCenters]="hideCenters()"
  [hideUserDropdown]="hideUserDropdown()"
  [hideNotifications]="hideNotifications()"
  [hideLanguageSelector]="hideLanguageSelector()"
  [showDarkModeToggle]="showDarkModeToggle()"
  [darkModeToggleContext]="darkModeToggleContext()"
></atlas-top-bar-items>
